import {layoutMarkup} from "../layout/layoutMarkup.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import EditorHelpers from "../../common/EditorHelpers";
import {listDefaultContent} from './listSectionDefaultContent';
import {componentsHelper} from "../../helpers/componentsHelper";
import l10n from "../../../lang/locallang";

const listSection = (param, is_public = false) => {
    componentsHelper.updateLocalization(listDefaultContent);
    const { listTexts } = l10n;
    param.class = param.class ? param.class : 'editor-section';
    let defaultContent = {
        0 : `${listTexts[0].content}`,
        1 : `${listTexts[1].content}`,
        2 : `${listTexts[2].content}`,
    }
    let contentList = param.content && param.content.list ? param.content.list : defaultContent;
    param.style = param.style ? param.style : '';
    param.layout = param['@layout'] ? param['@layout'] : 'listOl';
    param.section = 'listSection';
    let content = '';
    for(let item in contentList){
        content += `<li ${is_public ? `class="js-animated-li"` : ''}>${contentList[item]} &nbsp;</li>`;
    }
    param.component = `
            <div class="editor-section_container fr-editor-container">
                <div class="fr-editor-list">
                    ${param.layout == 'listUl' ? `<ul>${EditorHelpers.fixEncoding(content)}</ul>` : ''}
                    ${param.layout == 'listOl' ? `<ol>${EditorHelpers.fixEncoding(content)}</ol>` : ''}
                    ${param.layout == 'listCheckbox' ? `<ul class="checkbox-list">${EditorHelpers.fixEncoding(content)}</ul>` : ''}
                </div>
            </div>`;

    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export {listSection};
